<script>
  import {getUgSearch, getUgSearchUrl, getUgTabText} from './UG'
  // import SongSearch from "../../../quickchords-vue/src/components/SongSearch";
  import SongSearch from '/Users/steven/dev/projects/other/quickchords-vue/src/components/SongSearch'
  import ugParser from '/Users/steven/dev/projects/other/quickchords-vue/src/components/UGParser'

  export default {
    name: "UGSearch",
    extends: SongSearch,
    components: {SongSearch},
    data: function () {
      return {}
    },
    props: {
      proxyUrl: {type: String, required: true}
    },
    created() {
      this.serviceName = 'Ultimate Guitar'
    },
    methods: {
      getSearchItems(options) {
        options.proxyUrl = this.proxyUrl
        return getUgSearch(options).then(json => {
          return json.filter(it => it.type === 'Chords')
            .sort((a, b) => {
              let ret = b.votes - a.votes
              if (ret === 0) {
                ret = b.rating - a.rating
              }
              return ret
            })
        })
      },
      _removeChordDiagrams: function (text) {
        return text.replace(/\b[x\d]{4,}\b/g, '');
      },
      getDocument(url, options) {
        options.proxyUrl = this.proxyUrl
        return getUgTabText(options.proxyUrl, url).then(text => {
          // replace embedded chord diagrams
          text = this._removeChordDiagrams(text)
          const doc = ugParser(text, options)
          return doc
        })
      },
      getSearchUrl(options) {
        return getUgSearchUrl(this.options)
      }
    },
    computed: {}
  }
</script>